module.exports = __webpack_public_path__ + "472cd20453ee7ba7aed4938c02b92a60.png";